import React, { FunctionComponent } from 'react';
import './SelectableDiv.scss';

type SelectableDivProps = {
    onClicked: (selected: boolean) => void;
    id: string;
    selected: boolean;
    style?: React.CSSProperties;
    children?: React.ReactNode;
};

const SelectableDiv: FunctionComponent<SelectableDivProps> = ({
    onClicked,
    id,
    selected,
    style,
    children
}) => {
    const selectedStyle = selected ? 'selectable-div-selected' : '';
    const mainStyle = 'selectable-div-container ' + selectedStyle;

    const onClick = () => {
        const selctedValue = !selected;
        onClicked(selctedValue);
    };

    return (
        <div id={id} className={mainStyle} style={style} onClick={onClick}>
            {children}
        </div>
    );
};

export default SelectableDiv;
